export const DEBOUNCE_DELAYS = {
  TYPING: 250, // used for search fields
  FORM_TYPING: 800, // used for form fields to delay error from showing when user first starts typing
};
